const imageCache = new Map();
const inflight = new Map();

export function getCachedImage(url) {
  return imageCache.get(url) || null;
}

export function preloadImage(url) {
  if (!url) return Promise.resolve(null);
  if (imageCache.has(url)) return Promise.resolve(imageCache.get(url));
  if (inflight.has(url)) return inflight.get(url);

  const task = new Promise((resolve) => {
    const img = new Image();
    img.decoding = "async";
    const finish = () => {
      imageCache.set(url, img);
      inflight.delete(url);
      resolve(img);
    };
    img.onload = () => {
      if (typeof img.decode === "function") {
        img.decode().then(finish).catch(finish);
        return;
      }
      finish();
    };
    img.onerror = () => {
      inflight.delete(url);
      resolve(null);
    };
    img.src = url;
  });

  inflight.set(url, task);
  return task;
}

export function preloadVideo(url) {
  if (!url) return Promise.resolve(null);
  return new Promise((resolve) => {
    const video = document.createElement("video");
    video.muted = true;
    video.preload = "auto";
    video.playsInline = true;
    const done = () => resolve(video);
    video.addEventListener("canplaythrough", done, { once: true });
    video.addEventListener("error", () => resolve(null), { once: true });
    window.setTimeout(done, 8000);
    video.src = url;
    video.load();
  });
}

export function preloadStoryItems(items = []) {
  return Promise.all(
    items.flatMap((item) => {
      const jobs = [];
      const frames = Array.isArray(item?.media_blocks) ? item.media_blocks : [];
      frames.forEach((block) => {
        if (!block?.url) return;
        if (block.type === "video") jobs.push(preloadVideo(block.url));
        else jobs.push(preloadImage(block.url));
      });
      if (!frames.length && item?.media_url) {
        if (item.media_type === "video") jobs.push(preloadVideo(item.media_url));
        else jobs.push(preloadImage(item.media_url));
      }
      return jobs.length ? jobs : [Promise.resolve(null)];
    })
  );
}
